import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  ANY_SPORT_SCORES_MATCHES,
  ANY_SPORT_SCORES_TOP_PLAYERS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { glossary, navLabels } from '@sorare/core/src/lib/glossary';

const ScoresLayout = () => {
  const { generateSportContextPath, sport } = useSportContext();
  return (
    <>
      <PageHeader text={navLabels.scores} disableBackBrowser />
      <ContentWithStickyHeader
        header={
          <TabBar variant="flat" fullWidth>
            <Tab to={generateSportContextPath(ANY_SPORT_SCORES_MATCHES)}>
              <FormattedMessage
                {...(sport === Sport.FOOTBALL
                  ? glossary.matches
                  : glossary.games)}
              />
            </Tab>
            <Tab to={generateSportContextPath(ANY_SPORT_SCORES_TOP_PLAYERS)}>
              <FormattedMessage {...glossary.topPlayers} />
            </Tab>
          </TabBar>
        }
      >
        <Outlet />
      </ContentWithStickyHeader>
    </>
  );
};

export default ScoresLayout;
